import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Radio,
  RadioGroup,
  FormControlLabel,
  Box,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { updateAirlinkRemoteType } from "../../../containers/Admin/AirlinkDevices/actions";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    fontSize: "20px",
    fontWeight: 700,
    color: "#4f6477",
    padding: "0 0 2px 0 !important",
    textAlign: "center",
    textTransform: "uppercase",
  },

  description: {
    fontSize: "15px",
    color: "#4f6477",
    margin: "0",
    padding: "0 0 24px 0 ",
    textAlign: "center",
  },

  radioGroup: {
    width: "100%",
  },
  radioCard: {
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    padding: "8px 8px 8px 0",
    margin: "0 0 16px 0 !important",
    width: "100%",
    display: "flex",
    alignItems: "center",
    minHeight: "56px",
    position: "relative",
    transition: "all 0.2s ease-in-out",
    cursor: "pointer",
    "&:hover": {
      borderColor: "#009a71",
      backgroundColor: "#eefaf6",
    },
    "& .MuiFormControlLabel-root": {
      width: "100%",
      margin: 0,
    },
  },
  selectedCard: {
    borderColor: "#009a71",
    backgroundColor: "#eefaf6",
    "& .MuiTypography-root": {
      color: "#212121",
      fontWeight: 500,
    },
  },

  radioLabel: {
    fontSize: "15px",
    fontWeight: 500,
    color: "#333",
    lineHeight: "1.4",
    paddingRight: "60px",
  },
  customRadio: {
    color: "#bdbdbd",
    "&$checked": {
      color: "#009a71",
    },
  },

  checked: {},
  actions: {
    padding: "0 !important",
    margin: "0 auto !important",
    justifyContent: "center",
    "& .button-btn": {
      minWidth: "140px",
      height: "48px",
      fontSize: "16px",
      fontWeight: 700,
      borderRadius: "8px",
      textTransform: "uppercase",
    },
    "& .btn-custom-black": {
      backgroundColor: "#536677 !important",
      color: "#fff !important",
    },
    "& .btn-custom-primary": {
      backgroundColor: "#3fb294 !important",
      color: "#fff !important",
    },
  },
}));

export default function UpdateRemoteTypeModal(props) {
  const classes = useStyles();

  const { details, refreshData } = props?.globalModal?.data || {};
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const currentValue = details?.ac_name?.includes("VRF") ? "vrf" : "rac";
  const [selectedValue, setSelectedValue] = useState(currentValue);

  const closeModal = () => {
    props.closeModal();
  };

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const onSubmit = async () => {
    if (!selectedValue) return;

    setIsLoading(true);
    const request = {
      device_id: details?.id,
      kfid: selectedValue,
      hw_id: details?.mac_address,
      serial_number: details?.serial_number,
      property_id: details?.property_id,
    };
    dispatch(updateAirlinkRemoteType(request))
      .then((res) => {
        if (refreshData) {
          refreshData();
        }
        closeModal();
      })
      .catch((err) => {
        console.log(err.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <DialogTitle className={`${classes.dialogTitle} pb-0`}>
        Change Remote Type
      </DialogTitle>
      <Typography className={classes.description}>
        Choose the remote type you wish to switch to:
      </Typography>

      <DialogContent className="pt-0 px-0">
        <FormControl component="fieldset" className="w-100">
          <RadioGroup
            aria-label="remote-type"
            name="remote-type"
            value={selectedValue}
            onChange={handleChange}
            className={classes.radioGroup}
          >
            <Box
              className={`${classes.radioCard} ${selectedValue === "rac" ? classes.selectedCard : ""}`}
            >
              <FormControlLabel
                value="rac"
                control={
                  <Radio
                    classes={{
                      root: classes.customRadio,
                      checked: classes.checked,
                    }}
                    color="default"
                  />
                }
                label={
                  <span className={classes.radioLabel}>
                    Emerald Select and Pro RAC Systems
                  </span>
                }
              />
            </Box>

            <Box
              className={`${classes.radioCard} ${selectedValue === "vrf" ? classes.selectedCard : ""}`}
            >
              <FormControlLabel
                value="vrf"
                control={
                  <Radio
                    classes={{
                      root: classes.customRadio,
                      checked: classes.checked,
                    }}
                    color="default"
                  />
                }
                label={
                  <span className={classes.radioLabel}>
                    Emerald Ultra VRF Systems
                  </span>
                }
              />
            </Box>
          </RadioGroup>
        </FormControl>
      </DialogContent>

      <DialogActions className={`${classes.actions} dialog-btns modal-add-pdf`}>
        <Button
          className={`button-btn btn-custom-black mr-3 ${isLoading ? "disabled" : ""}`}
          onClick={closeModal}
        >
          Cancel
        </Button>
        <Button
          className={`button-btn btn-custom-primary ${isLoading ? "disabled" : ""}`}
          onClick={isLoading ? null : onSubmit}
        >
          {isLoading ? <CircularProgress size={18} color="white" /> : "Update"}
        </Button>
      </DialogActions>
    </>
  );
}
